import { Box } from '@mui/material';
import { useMemo, useState } from 'react';
import { CodPositions } from 'src/constants';

import { ChannelTabPanel } from './ChannelTabPanel';
import { ChannelTabs } from './ChannelTabs';
import {
  IChannelType,
  IScreenConfigSection,
} from './ScreenConfigSection.interface';

export const ScreenConfigSection = ({
  projectConfig,
  globalComponentsScreensState = {},
  handleChange,
}: IScreenConfigSection) => {
  const { globalComponents = [], codPosition = CodPositions.LEFT } =
    projectConfig ?? {};

  const channelTypes: IChannelType[] = useMemo(() => {
    return Object.keys(globalComponentsScreensState)
      .map((key) => {
        return {
          label: key,
          screenNumber: globalComponentsScreensState[key]?.[0].screenNumber,
          screenLayouts: globalComponentsScreensState[key]?.map((screen) => ({
            layoutType: screen.screenLayoutType,
            globalComponents: screen.globalComponents,
          })),
        };
      })
      .reverse();
  }, [globalComponentsScreensState]);

  const [selectedTab, setSelectedTab] = useState(channelTypes?.[0]?.label);

  return (
    <Box>
      <ChannelTabs
        channelTypes={channelTypes}
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
      />

      {channelTypes.map((channelType) => (
        <ChannelTabPanel
          key={channelType.label}
          channelType={channelType}
          selectedTab={selectedTab}
          globalComponents={globalComponents}
          codPosition={codPosition}
          handleChange={handleChange}
        />
      ))}
    </Box>
  );
};
